<template>
  <div class="mediaLeft" :class="{ 'vogue-media': theme == 'vogue' }">
    <div class="leftImg">
      <!-- <v-slide-vertical :gallery="gallery" :style="{height:slideHeight}"></v-slide-vertical> -->
      <v-scroll-slide-vertical :gallery="gallery" :style="{height:slideHeight}" :swiper-index="swiperIndex"></v-scroll-slide-vertical>
    </div>
    <div class="rightImg">
      <v-product-tag v-if="is_product&&$store.state.product_tag_list[product_res.ID]" :productTag="$store.state.product_tag_list[product_res.ID]" :productInfo="productInfo"></v-product-tag>
      <swiper
        ref="swiperTop"
        :options="swiperOptionTop"
        class="swiper swiper-container"
        :class="{ 'swiper-no-swiping': gallery.length <= 1 }"
        @slideChange="slideChange"
      >
        <swiper-slide
          v-for="item in gallery"
          :key="item.ID"
          style="text-align: center;opacity: 0;"
        >
          <!-- 用户上传视频 -->
          <template v-if="item.media_content_type === 'video'">
            <v-video-player :poster="item.thumbnail" :video-src="item.url" :muted="true" :show-play-button="false" />
          </template>

          <!-- youtube视频 -->
          <template v-else-if="item.media_content_type === 'external_video'">
            <div class="mediaLeft__iframe-wrapper">
              <iframe
                class="mediaLeft__iframe"
                :src="item.url"
                :video-src="item.url"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              >
              </iframe>
            </div>
          </template>
           <!-- 普通图片 -->
          <template v-else>
            <v-picZoom
              v-if="pic_zoom"
              :url="item.url"
              :bigUrl="item.url"
              :appendToBody="true"
            ></v-picZoom>
            <v-lazy-img
              v-else
              data-sizes="auto"
              :data-url="item.url"
              class="swiper-lazy"
              @load="swiperTop.update()"
              @mousemove.native.prevent
            />
          </template>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import vSlideVertical from "./slideVertical";
import VScrollSlideVertical from "./scrollSlideVertical.vue"
import VideoPlayerVue from '@/js/components/VideoPlayer.vue'
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import { playVideo } from '@/js/lib/util';
import vPicZoom from '@/js/components/common/picZoom.vue'

export default {
  props: ["gallery", "pic_zoom", "theme","product_res","is_product","productInfo",
    'autoplay'
  ],
  data() {
    let self = this
    return {
      // defaultImage,
      swiperOptionTop: {
        spaceBetween: 10,
        effect: "fade",//淡入
        fadeEffect: {//淡出
          crossFade: true,
        },
        autoHeight: true, //enable auto height
        roundLengths: true,
        // 自动播放
        autoplay: this.autoplay ? {
          delay: 2000,
          disableOnInteraction: false
        } : false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: this.handChangeEnd,
          slideChange: function(){
            self.swiperIndex.activeIndex = this.activeIndex
          },
        }
      },
      el: null,
      slideHeight:'500px',
      swiperIndex:{
        activeIndex:0
      }
    };
  },
  computed: {
    swiperTop() {
      return this.$refs.swiperTop.swiper;
    },
  },
  components: {
    VScrollSlideVertical,
    vSlideVertical,
    [VideoPlayerVue.name]: VideoPlayerVue,
    vProductTag,
    vPicZoom
  },
  mounted() {
    // 保存当前的dom
    const dom = this.$refs.swiperTop?.swiper?.el
    this.el = dom;

    // 当前可能是视频需要播放
    const thisVideoDom = dom && Jq(dom)?.find('.swiper-slide-active [video-src]')?.[0]

    console.log('this.dom', thisVideoDom)

    if (thisVideoDom) playVideo(thisVideoDom, 1)

    this.observer = new ResizeObserver( entries =>{
      this.slideHeight = entries[0].contentRect.height+'px'
    })
    this.observer.observe(this.$refs.swiperTop.$el)

  },
  methods: {
    slideChange() {

      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]
      if (!videoDom) return

      playVideo(videoDom, 0)
    },
    // 结束切换
    handChangeEnd(a) {
      // 如果是视频的话,就播放视频
      // const dom = Jq('.product-swiper .swiper-slide.swiper-slide-active [video-src]')?.[0]

      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]
      if (!videoDom) return
      playVideo(videoDom, 1)
    },
  },
  watch: {
    "$store.state.feature_image_id"() {
      this.gallery.some((item, index) => {
        if (item.ID == this.$store.state.feature_image_id) {
          console.log(this.$store.state.feature_image_id);
          this.swiperTop.slideTo(index);
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
.mediaLeft {
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  max-width: 100vw;
  &__iframe-wrapper {
    width: 100%;
    max-width: 100vw;
    height: 0;
    padding-bottom: 80%;
    position: relative;
  }
  &__iframe {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 2;
    top: 0;
    left: 0;
  }
  .leftImg {
    width: 16%;
  }
  .rightImg {
    position: relative;
    margin-left: 20px;
    vertical-align: top;
    width: calc(100% - 120px)
  }
  .swiper {
    background-color: rgba(255, 255, 255, 0);
    .swiper-slide {
      background-color: rgba(255, 255, 255, 0);
      text-align: left !important;
      min-height: 500px !important;
      opacity: 0 !important;
    }
    &::v-deep{
      .swiper-wrapper{
        min-height: 500px !important;
      }
    }
    .swiper-slide-active{
      opacity: 1 !important;
    }
  }
}
.vogue-media {
  .leftImg {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
  }
}
@media screen and (min-width: 1200px) {
  .vogue-media {
    .leftImg {
      width: 100px;
      min-width: 100px;
      max-width: 100px;
    }
    .rightImg {
      width: 500px;
      margin: 0 20px;
    }
  }
}
</style>
